{
  "fr": {
    "survey": {
      "actions": {
        "add": "Ajouter",
        "addDescription": "Ajouter une description",
        "close": "Fermer",
        "create": "Créer",
        "createNew": "Nouveau",
        "delete": "Supprimer",
        "deleteCount": "Vous êtes sur le point de supprimer {count} formulaire. Êtes-vous sûr? | Vous êtes sur le point de supprimer {count} formulaires. Êtes-vous sûr?",
        "deleteMultiple": "Supprimer...",
        "delete_cancel": "Annuler",
        "delete_surveys": "Supprimer formulaire | Supprimer formulaires",
        "importTemplate": "Importer",
        "newSurvey": "Formulaire",
        "publish": "Publier",
        "publishCustomer": "Publier pour vos clients",
        "revokeAccess": "Révoquer l'accès",
        "save": "Enregister",
        "selectAll": "Sélectionner tous les {total} formulaires",
        "send": "Envoyer",
        "sendCustomer": "Envoyer au client",
        "submit": "Soumettre",
        "surveys_collapse": "Réduire les formulaires",
        "surveys_expand": "Élargir les formulaires",
        "unSelectAll": "Effacer la sélection",
        "unpublish": "Annuler la publication"
      },
      "attributes": {
        "description": "Titre interne",
        "title": "Votre question"
      },
      "labels": {
        "NPSOverview": "La vue d'ensemble du NPS",
        "NPSQuestion": "Quelle est la probabilité que vous recommandiez {name} à vos amis et à votre famille?",
        "addQuestion": "Question",
        "allUnitsAssigned": "Toutes les unités ont été assignées",
        "answerRequired": "Réponse (obligatoire)",
        "answer_later": "Répondre plus tard",
        "answeredAt": "Répondu à",
        "average_score": "Score moyen",
        "clientTeam": "L'équipe {name}",
        "comments": "Commentaires ou suggestions? (facultatif)",
        "completedTime": "Répondu",
        "customer": "Client",
        "customer_status": "Statut",
        "detractors": "Détracteurs",
        "dissatisfied": "Insatisfait",
        "extremelyLikely": "Extrêmement probable",
        "lets_go": "Allons-y",
        "list": "La relève",
        "mostRecentAnswers": "Réponses les plus récentes",
        "neither_satisfied_nor_dissatisfied": "Ni satisfait ni insatisfait",
        "neutrals": "Neutres",
        "noAnswers": "Pas de réponse pour l'instant",
        "noSurveyFeedback": "Pas de commentaires ou de suggestions",
        "noSurveysYet": "Aucun sondage pour le moment. Créez votre premier sondage pour commencer.",
        "noUnitsClick": "Pas encore d'unités, cliquer ici pour ajouter",
        "no_opinion": "Pas d'opinion",
        "notAtAllLikely": "Pas du tout probable",
        "nps": "NPS",
        "numberAnswered": "{answered} réponses sur {total}",
        "obligatory": "Rendre une formulaire obligatoire pour les clients",
        "pendingSurveys": " Nous avons besoin de vos commentaires",
        "promoters": "Promoteurs",
        "publishNow?": "Publier maintenant?",
        "published": "Publié",
        "publishedCount": "Publier cette formulaire sur le client | Publier {count} formulaires sur le client",
        "question": "Question",
        "question_number": "Question {current_number} sur {total_questions}",
        "questions": "Questions",
        "respondents": "Aucun répondant | 1 repondant | {count} répondants",
        "response": "Réponse",
        "responseTime": "Temps de réponse",
        "responses": "Réponses",
        "revokeAccessCount": "Révoquer l'accès à cette enquête pour les clients Révoquer l'accès à cette enquête pour les clients {count} ",
        "satisfied": "Satisfait",
        "saveExplainer": "Voulez-vous rendre cette formulaire visible pour vos clients immédiatement? Ou préférez-vous l'enregistrer d'abord et la plublier plus tard?",
        "scoreBreakdown": "La repartition du score",
        "selectOneUnit": "Sélectionnez au moins 1 formulaire",
        "selectUnits": "Selectionner les unités",
        "selected": "{selected} formulaire est sélectionnée. | {selected} formulaires sont sélectionnées",
        "sendCount": "Envoyer cette formulaire au client | Envoyer des formulaires aux clients {count} ",
        "sendExplainer": "Le client le verra sur son tableau de bord",
        "sendNow?": "Envoyer maintenant ?",
        "sent": "Envoyé",
        "sentCustomer": "Envoyé au client",
        "showSurveysFor": "Afficher les formulaires pour",
        "showingResultsFor": "Montrer les résultats pour",
        "step0Title": "Quel modèle de projet et de formulaire souhaitez-vous utiliser ?",
        "step2Subtitle": "De cette façon, vos clients sauront mieux quel est le but de cette formulaire",
        "step2Title": "Ajouter une courte introduction",
        "step3Subtitle": "Sélectionnez votre projet pour inclure toutes vos unités à la fois.",
        "step3Title": "Pour quelles unités souhaitez-vous créer cette formulaire?",
        "survey": "Formulaire",
        "surveyAlreadyAnswered": "Une formulaire a déjà été répondu. Merci pour vos commentaires.",
        "surveyAnswer": "Commentaire",
        "surveyNotCompleted": "Une formulaire n'est pas encore terminé",
        "surveys": "Formulaires",
        "surveysCount": "{count} formulaire | {count} formulaires",
        "surveys_all_projects": "Formulaires tous les projets",
        "tabOverview": "Aperçu",
        "tabSurveys": "Formulaires",
        "thankYou": "Merci pour vos commentaires",
        "title": "Question",
        "titles_must_be_unique": "Il y a des questions en double. Les questions doivent être uniques!",
        "totalSelected": "Touts les {count} formulaires sont sélectionnés",
        "unanswered": "Sans réponse",
        "unit": "Unité",
        "unitSelected": "Aucune unité à été sélectionnée pour le moment | Une unité sélectionnée | {count} unités sélectionnées",
        "units": "Unités",
        "unitsWithoutSurvey": "{count} unité sans formulaire | {count} unités sans formulaires.",
        "unpublishedCount": "Annuler la publication de cette formulaire | Annuler la publication de {count} formulaires",
        "very_dissatisfied": "Très insatisfait",
        "very_satisfied": "Très satisfait",
        "visibility": "Visibilité",
        "yourAnswers": "Vos réponses",
        "yourQuestion": "Votre question"
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Demandez votre clients pour leurs commentaires",
            "title": "Créez votre premier formulaire"
          },
          "none": {
            "subtitle": "Demandez votre clients pour leurs commentaires",
            "title": "Aucun formulaire trouvé"
          }
        }
      },
      "toasts": {
        "bulk_create": "Formulaire a été créé avec succès | Formulaires créés avec succès",
        "bulk_delete": "Formulaire a été supprimé avec succès | Formulaires supprimés avec succès",
        "bulk_update": "Formulaire a été mise à jour avec succès | Formulaires mises à jour avec succès",
        "update": "Formulaire mise à jour avec succès"
      },
      "validation": {
        "needName": "Entrer une question",
        "needQuestion": "Ajoutez au moins 1 question",
        "selectUnit": "Sélectionner au moins 1 unité"
      }
    }
  }
}
